import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.scss';

const WidgetHeader = ({
    anchorLink = '',
    clickEvent = Object.getPrototypeOf(Function),
    gtmTag = '',
    heading = '',
    icon = '',
    isClickEvent = false,
    isFavouriteSport = false,
    linkText = '',
}) => {

    const gtmAttribute = isClickEvent ? gtmTag : '';
    const headerClass = classNames('widget-header', {'widget-header--link': isClickEvent});
    const iconClass = classNames({[`widget-header__icon widget-header__icon-${icon}`]: icon !== ''});

    const content = () => {
        return (
            <>
                <div className={iconClass}></div>
                <h2 className='widget-header__text'>
                    {heading}
                    {isFavouriteSport && <div className='fav-sports-star'/>}
                </h2>
                {isClickEvent && linkText !== '' &&
                    <div className='widget-header__link'>{linkText}</div>
                }
            </>
        );
    };

    const clickLink = () =>
        <div className={headerClass} onClick={clickEvent} data-spectate-product={gtmAttribute}>
            {content()}
        </div>;

    const hrefLink = () =>
        <a className={headerClass} href={anchorLink} data-spectate-product={gtmAttribute}>
            {content()}
        </a>;

    return (
        <>
            {anchorLink
                ? hrefLink()
                : clickLink()
            }
        </>
    );

};

WidgetHeader.propTypes = {
    anchorLink: PropTypes.string,
    clickEvent: PropTypes.func,
    gtmTag: PropTypes.string,
    heading: PropTypes.string.isRequired,
    icon: PropTypes.string,
    isClickEvent: PropTypes.bool,
    isFavouriteSport: PropTypes.bool,
    linkText: PropTypes.string,
};

export default WidgetHeader;
